import { getEnv } from "@istari-frontend/shared";

/** Whom a refused person should contact: free text from VITE_ADMIN_CONTACT, or undefined when unset. */
export function adminContact(): string | undefined {
  const value = getEnv("VITE_ADMIN_CONTACT")?.trim();
  return value ? value : undefined;
}
